import axios from "axios";

const NOMINATIM = "https://nominatim.openstreetmap.org";

export async function geocode(query) {
  if (!query) return [];
  const { data } = await axios.get(`${NOMINATIM}/search`, {
    params: { q: query, format: "json", limit: 5, addressdetails: 1 },
  });
  return data.map((d) => ({
    lat: parseFloat(d.lat),
    lng: parseFloat(d.lon),
    address: d.display_name,
  }));
}

export async function reverseGeocode(lat, lng) {
  try {
    const { data } = await axios.get(`${NOMINATIM}/reverse`, {
      params: { lat, lon: lng, format: "json" },
    });
    return data.display_name || `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
  } catch {
    return `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
  }
}
